import { Locale } from '@iss/libs/graphql';
import { Pipe, PipeTransform } from '@angular/core';

import { Countries, Country } from './country-input.types';

@Pipe({
  name: 'find',
  standalone: true,
})
export class FindPipe implements PipeTransform {
  public transform(countries: Countries, code: Locale): Country | undefined {
    return countries.find(country => country.code === code);
  }
}
